<template>
  <component :is="as" :class="classes">
    <slot />
  </component>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export const variants = ['solid-primary', 'solid-dark', 'solid-emerald'];

export default {
  name: 'ELabel',
  mixins: [classes],
  props: {
    as: {
      type: String,
      default: 'span',
    },
    variant: {
      type: String,
      validator: (variant) => variants.includes(variant),
      default: 'solid-primary',
      cssClass: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$variants: (
  solid-primary: (
    background-color: $color-brand-primary,
  ),
  solid-dark: (
    background-color: $gray-60,
  ),
  solid-emerald: (
    background-color: $emerald-50,
  ),
);
$height: $space-l;

.label {
  display: inline-flex;
  align-items: center;
  height: $height;
  font-size: $font-1s;
  padding-left: $space-s;
  padding-right: $space-s;
  border-radius: $border-radius-full;
  color: $color-text-tertiary;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@each $name, $variant in $variants {
  $background-color: map-get($variant, 'background-color');

  .label--variant-#{$name} {
    background-color: $background-color;
  }
}
</style>
